import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { Card } from 'react-bootstrap';
import apiAxios from '../../../config/ApiAxios';
import { useQuery } from '../../../utils/useQuery';
import { useHistory } from 'react-router-dom';
import { handleGraficosParams } from '../../../utils/handleGraficosParams';

const PuntosDeVentas = () => {
	const [series, setSeries] = useState([
		{
			name: 'Prestado',
			data: [],
		},
		{
			name: 'Disponible',
			data: [],
		},
	]);

	const [categories, setCategories] = useState([]);

	useEffect(() => {
		const obtenerCreditos = async () => {
			try {
				const apiResponse = await apiAxios.get(
					`/reportes/global/puntos-venta`
				);
				const data = apiResponse.data;

				if (Array.isArray(data)) {
					const nombres = data.map((p) => p.nombre);
					const prestado = data.map((p) =>
						parseFloat(p.prestado)
					);
					const disponible = data.map((p) =>
						parseFloat(p.disponible)
					);

					setCategories(nombres);
					setSeries([
						{ name: 'Prestado', data: prestado },
						{ name: 'Disponible', data: disponible },
					]);
				}
			} catch (e) {
				console.error(e);
			}
		};

		obtenerCreditos();
	}, []);

	const options = {
		chart: {
			type: 'bar',
			height: 350,
			stacked: true,
		},
		stroke: {
			width: 1,
			colors: ['#fff'],
		},
		dataLabels: {
			formatter: (val) =>
				new Intl.NumberFormat('es-ES', {
					style: 'decimal',
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				}).format(val),
		},
		plotOptions: {
			bar: {
				horizontal: true,
			},
		},
		tooltip: {
			y: {
				formatter: (val) =>
					new Intl.NumberFormat('es-ES', {
						style: 'decimal',
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}).format(val),
			},
		},
		xaxis: {
			categories: categories,
			labels: {
				formatter: (val) =>
					new Intl.NumberFormat('es-ES', {
						style: 'decimal',
						maximumFractionDigits: 0,
					}).format(val),
			},
		},
		fill: {
			opacity: 1,
		},
		colors: ['#008FFB', '#00E396'],
		legend: {
			position: 'top',
			horizontalAlign: 'left',
		},
	};

	const query = useQuery();
	const history = useHistory();

	const ocultarGrafico = query.get('ocultarGrafico');
	const ocultarGraficoArray = ocultarGrafico
		? ocultarGrafico.replace(/[[\]]/g, '').split(',').map(Number)
		: [];

	return (
		<Card
			style={{
				display: ocultarGraficoArray.includes(6) ? 'none' : 'block',
			}}>
			<Card.Body>
				<Card.Title>
					Capital Prestado vs Disponible por Punto de Venta
					<button
						title="Ocultar"
						className="btn btn-light ms-2"
						onClick={() =>
							handleGraficosParams(
								6,
								ocultarGraficoArray,
								history
							)
						}>
						<i className="bi bi-eye"></i>
					</button>
					<a
						title="Este gráfico muestra el capital prestado y el disponible por punto de venta."
						className="btn btn-light ms-2"
						disabled>
						<i className="bi bi-info-circle"></i>
					</a>
				</Card.Title>
				<Chart
					options={options}
					series={series}
					type="bar"
					height={350}
				/>
			</Card.Body>
		</Card>
	);
};

export default PuntosDeVentas;
